import axios from '../axios-config';

export const NAVIGATION_GUARD_STATE = { __navigationGuard: true };

/**
 * Safely extracts the user id from the stored auth token payload.
 */
const getUserIdFromToken = () => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) return null;
    const base64 = token.split('.')[1];
    if (!base64) return null;
    const json = atob(base64.replace(/-/g, '+').replace(/_/g, '/'));
    const decoded = JSON.parse(json);
    return decoded?._id || decoded?.id || decoded?.userId || null;
  } catch {
    return null;
  }
};

const VALID_ERROR_TYPES = ['page_refresh', 'browser_back', 'unknown_error'];

/**
 * Tracks user navigation attempts during processing using the updateError API.
 */
export const trackNavigationEvent = async (payload) => {
  try {
    const errorType = payload.errorType || payload.eventType || 'unknown_error';
    const safeErrorType = VALID_ERROR_TYPES.includes(errorType) ? errorType : 'unknown_error';

    const response = await axios.post('/audio-engineer/v1/create-error', {
      userId: payload.userId || getUserIdFromToken(),
      uploadId: payload.uploadId || null,
      mixesUploadId: payload.mixesUploadId || null,
      taskId: payload.taskId || null,
      roex_task_id: payload.roexTaskId || null,
      operationName: payload.operationName || 'user_navigation',
      errorMessage: payload.errorMessage || `User attempted to ${safeErrorType.replace(/_/g, ' ')} during processing`,
      errorCode: payload.errorCode || null,
      errorDetails: payload.errorDetails || null,
      errorType: safeErrorType,
      source: payload.source || 'frontend',
      severity: payload.severity || 'medium',
      failureReason: payload.failureReason || null,
      statusCode: payload.statusCode || null,
      stackTrace: payload.stackTrace || null,
      metadata: {
        pagePath: payload.pagePath || window.location.pathname,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        ...payload.metadata,
      },
      isResolved: payload.isResolved || false,
      retryCount: payload.retryCount || 0,
    });
    return response.data;
  } catch (error) {
    // Silently fail to avoid disrupting user experience
    console.warn('Failed to track navigation event:', error.message);
  }
};

/**
 * Creates a tracking payload with common fields.
 */
export const createTrackingPayload = (errorType, context = {}) => {
  return {
    errorType,
    eventType: errorType,
    taskId: context.taskId || null,
    uploadId: context.uploadId || context.recordId || null,
    mixesUploadId: context.mixesUploadId || null,
    roexTaskId: context.roexTaskId || null,
    operationName: context.operationName || 'user_navigation',
    pagePath: window.location.pathname,
    errorMessage: context.errorMessage || `User attempted to ${errorType.replace(/_/g, ' ')} during processing`,
    errorCode: context.errorCode || null,
    errorDetails: context.errorDetails || null,
    source: context.source || 'frontend',
    severity: context.severity || 'medium',
    failureReason: context.failureReason || null,
    statusCode: context.statusCode || null,
    stackTrace: context.stackTrace || null,
    metadata: {
      search: window.location.search,
      hash: window.location.hash,
      ...context.metadata,
    },
    isResolved: context.isResolved || false,
    retryCount: context.retryCount || 0,
  };
};
